import Repository from '../axios'

const resource = '/admin/sales/budget-tools'

export default {
  getBudgetToolList(filterQuery){
    return Repository.get(`${resource}?${filterQuery}`)
  },
  createBudgetTool(payload){
    return Repository.post(`${resource}`,payload)
  },
  getForecast(id){
    return Repository.get(`${resource}/${id}`)
  },
  updateBudgetTool(id,payload){
    return Repository.put(`${resource}/${id}`,payload)
  },
  deleteForecast(id){
    return Repository.delete(`${resource}/${id}`)
  },
  getFilteredBudgetToolFormulation(customer_id) {
    return Repository.get(`/admin/sales/budget-tool/filtered-formulation?customer_id=${customer_id}`)
  },
  downloadExcelDocument(customer_id,formulation_id,from,to){
    return Repository.get(`/admin/sales/budget-tool/export?customer_id=${customer_id}&formulation_id=${formulation_id}&from=${from}&to=${to}`,{
      responseType:'blob'
    })
  }
}
